import config from "./config";
var axios = config();

export default {
  getStudentOpportunities() {
    return axios.get(
      "/api/StudentOpportunities/GetStudentOpportunitiesActive",
      { params: {} }
    );
  },

  getApprovedStudentOpportunities(termId) {
    return axios.get(
      "/api/StudentOpportunities/GetApprovedStudentOpportunities?termid=" +
      termId,
      { params: {} }
    );
  },

  getApplicationStatus(termId) {
    return axios.get(
      "/api/StudentOpportunities/getApplicationStatus?termid=" + termId,
      {
        params: {}
      }
    );
  },

  getApplicationStatusCsv(termId) {
    return axios.get(
      "/api/StudentOpportunities/getApplicationStatusCsv?termid=" + termId,
      {
        params: {}
      }
    );
  },

  getCompletedStudents(termId) {
    return axios.get(
      "/api/StudentOpportunities/GetCompleted?termid=" + termId,
      {
        params: {}
      }
    );
  },

  getPendingStudents(termId) {
    return axios.get(
      "/api/StudentOpportunities/getPendingStudents?termid=" + termId,
      {
        params: {}
      }
    );
  },

  getStudentOpportunityById(studentOpportunityId) {
    return axios.get("/api/StudentOpportunities/GetStudentOpportunityById", {
      params: { id: studentOpportunityId }
    });
  },

  getAdditionalMaterialStatuses() {
    return axios.get(
      "/api/StudentOpportunities/GetAdditionalMaterialStatuses",
      {
        params: {}
      }
    );
  },

  getStudentNotes(studentOpportunityId) {
    return axios.get("/api/StudentOpportunities/GetActiveStudentNotes", {
      params: { StudentOpportunityId: studentOpportunityId }
    });
  },

  getStudentOpportunityTypes() {
    return axios.get("/api/StudentOpportunities/GetStudentOpportunityTypes", {
      params: {}
    });
  },

  postFileStatus(studentOpportunityAdditionalMaterialId, statusId) {
    return axios.post(
      "/api/StudentOpportunities/SetFileStatus?StudentOpportunityAdditionalMaterialId=" +
      studentOpportunityAdditionalMaterialId +
      "&StatusId=" +
      statusId,
      {}
    );
  },

  postFile(formData, files) {
    return axios({
      method: "POST",
      url: "/api/StudentOpportunities/AddFile",
      transformRequest: function (data) {
        var formData = new FormData();
        // need to convert our json object to a string version of json otherwise
        // the browser will do a 'toString()' on the object which will result
        // in the value '[Object object]' on the server.
        formData.append("data", JSON.stringify(data.data));
        //now add all of the assigned files
        for (var i = 0; i < data.files.length; i++) {
          //add each file to the form data and iteratively name them
          formData.append("file" + i, data.files[i]);
        }
        return formData;
      },
      data: { data: formData, files: files } // pass in data as strings
      //headers: { 'Content-Type': undefined }  // set the headers so angular passing info as form data (not request payload)
    });
  },

  postStudentOpportunity(studentOpportunity) {
    return axios.post(
      "/api/StudentOpportunities/PostStudentOpportunity",
      studentOpportunity
    );
  },

  postStudentOpportunityContact(studentOpportunity) {
    return axios.post(
      "/api/StudentOpportunities/AddStudentOpportunityContact",
      studentOpportunity
    );
  },

  createIlaApprovedEmail(studentOpportunityAdditionalMaterialId) {
    return axios.post(
      "/api/StudentOpportunities/CreateApprovedEmail/" +
      studentOpportunityAdditionalMaterialId
    );
  },

  createIlaApprovedSiteEmail(studentOpportunityId) {
    return axios.post(
      "/api/StudentOpportunities/CreateApprovedSiteEmail/" +
      studentOpportunityId
    );
  },
  postCallbackRequest(
    route,
    studentOpportunityId,
    studentOpportunityAdditionalMaterialId,
    options
  ) {
    if (!options) {
      options = {};
    }
    var params = "";
    if (studentOpportunityId) {
      params = params + studentOpportunityId + "/";
    }
    if (studentOpportunityAdditionalMaterialId) {
      params = params + studentOpportunityAdditionalMaterialId + "/";
    }
    return axios.post(route + params, options);
  },

  postUpdateClass(studentOpportunity) {
    return axios.post(
      "/api/StudentOpportunities/updateClass",
      studentOpportunity
    );
  },

  postUpdateHours(studentOpportunity) {
    return axios.post(
      "/api/StudentOpportunities/updateHours",
      studentOpportunity
    );
  }
};
